// extracted by mini-css-extract-plugin
module.exports = {"root":"hint-module--root--3TK3z","collapsed":"hint-module--collapsed--JMICV"};